import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useOutletContext, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet-async";
// componentes
import ZonaCargando from "../alertas/zonaCargando";
import CardVendedor  from "../../componentesEspeciales/cardVendedor";
import TipoYubicacion from "../../componentesEspeciales/crearEditar/tipoYubicacion";
import Llamanos from "../../componentesEspeciales/llamanos";
import ServiciosRelacionados from "../../componentesEspeciales/serviciosRelacionados";
// funciones
import { formatearMoneda } from "../../funcionesDatos/Moneda";
import { estrellas, normalizarResumen } from "../../funcionesDatos/Textos";
import { obtenerIdInvitado } from "../../funcionesDatos/idInvitado";
import { pixelVerContenido, pixelAgregarFavorito, pixelAgregarAlCarrito } from "../../funcionesDatos/pixelFacebook";
import { gtagVerContenido, gtagAgregarFavorito, gtagAgregarAlCarrito } from "../../funcionesDatos/pixelGoogle";
import { ttqVerContenido, ttqAgregarFavorito, ttqAgregarAlCarrito } from "../../funcionesDatos/pixelTiktok";
import { eventoVerContenido, eventoAgregarFavorito, eventoAgregarAlCarrito } from "../../funcionesDatos/eventoPropio";

// estilos
import "../../estilos/usuario.css";

function VerServicio() {
  const navigate      = useNavigate();
  const location      = useLocation();
  const { nombreYid } = useParams();

  // extraer el id del servicio desde la url
  // Formato esperado: "slug-<UUID>" (el slug puede tener muchos '-')
  const idServicio = (() => {
    const raw = (nombreYid || "").toString().trim();
    if (!raw) return null;
 
    // ✅ Buscar UUID completo al final
    const match = raw.match(
      /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
    );
    if (match?.[0]) return match[0];

    // Fallback si no viene UUID (por compatibilidad)
    const lastDash = raw.lastIndexOf("-");
    const id = lastDash >= 0 ? raw.slice(lastDash + 1) : raw;
    return (id || "").trim() || null;
  })();


  //console.log("idServicio", idServicio);

  // VARIABLES
  const { usuario, cargandoUsuario }      = useOutletContext() || {};
  const [cargando, setCargando]           = useState(false);
  const cargandoFinal                     = Boolean(cargandoUsuario) || Boolean(cargando);
  const [servicio, setServicio]           = useState(null);
  const [imagenExpandida, setImagenExpandida] = useState(null);
  const [paqueteActivo, setPaqueteActivo] = useState(null);
  const [desglosePorPaquete, setDesglosePorPaquete] = useState({}); // { [tipoPaquete]: desglose } — precio todo incluido (sin urgencia, es solo para mostrar el precio base al navegar)
  const [enWishlist, setEnWishlist]       = useState(false);
  
  // preguntas y respuestas del servicio
  const [preguntas, setPreguntas]             = useState([]);
  const [totalPreguntas, setTotalPreguntas]   = useState(0);
  const [hayMasPreguntas, setHayMasPreguntas] = useState(false);
  const [paginaPreguntas, setPaginaPreguntas] = useState(1);
  const [cargandoPreguntas, setCargandoPreguntas] = useState(false);
  const [nuevaPregunta, setNuevaPregunta]     = useState("");
  const [enviandoPregunta, setEnviandoPregunta] = useState(false);

  // valoraciones
  const [valVendedor, setValVendedor]         = useState([]);
  const [valServicio, setValServicio]         = useState([]);
  const [vendedor, setVendedor]               = useState(null);
  const [resuServicio, setResuServicio]       = useState(null); // cantidad, valoracionFinal, cantidadEstrellas
  const [resuVendedor, setResuVendedor]       = useState(null); // cantidad, valoracionFinal, cantidadEstrellas
  const [valDestacadas, setValDestacadas]     = useState([]);
  const [valDestServicio, setValDestServicio] = useState([]);
  const [valDestVendedor, setValDestVendedor] = useState([]);
  

     
 

  // Al pasar de un servicio a otro (ej. desde "Servicios similares") React Router reutiliza esta
  // página y no vuelve arriba: lo hacemos manualmente para que se vea el servicio nuevo desde el inicio.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [idServicio]);

  // 2) Cargar servicio por id
  useEffect(() => {
    // Esta vista puede ser pública: `usuario` puede ser null.
    if (!idServicio) {
      Swal.fire({ icon: "info", title: "Falta el ID del servicio", text: "No se encontró el idServicio en la URL. Vuelve a la edición y entra de nuevo al preview." });
      return;
    }

    let mounted = true;

    async function cargarServicio() {
      setCargando(true);
      try {
        // enviamos NA porque necesitamos obtener el servicio solo, no los servicios para edutar del usuario
        const res = await axios.post("/buscar-servicio", {
          params: { usuario: "NA", idServicio }
        });

        if (!mounted) return; // variable que busca solo actualizar variables setState si el componente aún está montando. Si el usuario sale de la página, se ejecuta return y no actualiza variables.
        // realmente solo busca es evitar cargar datos a estas variables si sale de la pagina o se desmonta. 

        if (res?.data?.servicio) {
          const srv = res.data.servicio;
          //console.log("servicio: ", srv);
          setServicio(srv); 

          // Seleccionar el primer paquete por defecto
          const listaPaquetes = Array.isArray(srv.paquetes) ? srv.paquetes : [];
          if (listaPaquetes.length > 0) {
            setPaqueteActivo(listaPaquetes[0].tipo);
            // SE CREA PRIMERO EL VER CONTENIDO DE PIXEL DE FACEBOOK AL CARGAR, LUEGO ABAJO SE MODIFICA SI CAMBIA DE TAB DE PAQUETE
            pixelVerContenido({
              nombre:    srv.nombre,
              id:        srv.idServicio,
              precio:    listaPaquetes[0].precio || 0,
              categoria: srv.categoria || "",
            });
            gtagVerContenido({
              nombre:    srv.nombre,
              id:        srv.idServicio,
              precio:    listaPaquetes[0].precio || 0,
              categoria: srv.categoria || "",
            });
            ttqVerContenido({
              nombre:    srv.nombre,
              id:        srv.idServicio,
              precio:    listaPaquetes[0].precio || 0,
              categoria: srv.categoria || "",
            });
            eventoVerContenido({
              nombre:    srv.nombre,
              id:        srv.idServicio,
              precio:    listaPaquetes[0].precio || 0,
              categoria: srv.categoria || "",
              usuarioId: usuario?.idUsuario,
            });
          } else { setPaqueteActivo(null); }

          // reseñas (ahora vienen junto con /buscar-servicio)
          const data = res?.data || {};

          setValServicio(Array.isArray(data?.valoracionesServicio) ? data.valoracionesServicio : []);
          setValVendedor(Array.isArray(data?.valoracionesVendedor) ? data.valoracionesVendedor : []);
          setVendedor(data?.usuarioVendedor || null);

          // ✅ Resumen del servicio: preferimos el nuevo formato: servicio.resumenReseñas
          setResuServicio(normalizarResumen({ resumenServicio: data?.resumenServicio, resumenReseñas: srv?.resumenReseñas }));
          // Resumen vendedor (por ahora viene en formato viejo desde backend)
          setResuVendedor(normalizarResumen({ resumenServicio: data?.resumenVendedor }));

          // Destacadas
          setValDestServicio(Array.isArray(data?.valoracionesDestacadasServicio) ? data.valoracionesDestacadasServicio : []);
          setValDestVendedor(Array.isArray(data?.valoracionesDestacadasVendedor) ? data.valoracionesDestacadasVendedor : []);
          setValDestacadas(Array.isArray(data?.valoracionesDestacadas) ? data.valoracionesDestacadas : []);

          if (!data?.usuarioVendedor) {
            console.log("Advertencia: no se encontró usuarioVendedor para este servicio.");
          }

          // buscar si el usuario lo tiene en sus favoritos (solo si está logueado)
          if (usuario) {
            const favoritosDeUsuario = Array.isArray(usuario?.serviciosFavoritos) ? usuario.serviciosFavoritos : [];
            const estaEnFavoritos = favoritosDeUsuario.some((id) => String(id) === String(srv._id));
            setEnWishlist(estaEnFavoritos);
          } else {
            setEnWishlist(false);
          }
        }
        else {
          setServicio(null);
          Swal.fire({ icon: "error", title: "Servicio no encontrado", text: "No pudimos cargar el servicio. Verifica el ID o tus permisos." });
        }
      } 
      catch (err) {
        console.log("Error cargando servicio:", err);
        if (mounted) {
          Swal.fire({ icon: "error", title: "Error", text: "Ocurrió un error cargando el servicio." });
        }
      } 
      finally { if (mounted) setCargando(false); }
    }

    cargarServicio();
    return () => { mounted = false; };
  }, [usuario, idServicio]);

  // Precio todo-incluido (con comisión de Zervicy + fee de la pasarela) del paquete activo.
  // Usa la misma ruta /obtener-comisiones que ya usa Reserva.jsx — no se toca calcularDesgloseCobro,
  // así que no hay riesgo de romper el desglose que ya consume la app.
  useEffect(() => {
    // Esperamos a que se resuelva la sesión antes de pedir el desglose: si no, el precio podría
    // calcularse como anónimo (sin descuento de primera compra) y quedar en caché sin actualizarse.
    if (cargandoUsuario) return;
    if (!servicio?.pais || !paqueteActivo) return;

    const paquete = (servicio.paquetes || []).find((p) => p.tipo === paqueteActivo);
    if (!paquete?.precio) return;

    // Ya calculado para este paquete, no repetimos la llamada.
    if (desglosePorPaquete[paqueteActivo]) return;

    let cancelado = false;

    (async () => {
      try {
        const res = await axios.post("/obtener-comisiones", {
          params: { pais: servicio.pais, precio: paquete.precio, urgente: false, idComprador: usuario?.idUsuario }
        });
        const desglose = res?.data?.desglose || null;
        if (!cancelado && desglose) {
          setDesglosePorPaquete((prev) => ({ ...prev, [paqueteActivo]: desglose }));
        }
      } catch (err) {
        console.log("Error obteniendo desglose del paquete:", err);
      }
    })();

    return () => { cancelado = true; };
  }, [servicio, paqueteActivo, desglosePorPaquete, cargandoUsuario, usuario]);

  // 🔥 Tracking SEO / Analytics dinámico
  useEffect(() => {
    if (!servicio?.nombre) return;

    const tituloPagina = `${servicio.nombre} | Zervicy`;

    // Actualizar título del documento (refuerzo SEO en SPA)
    document.title = tituloPagina;

    // Enviar page_view manual a GA4 si existe gtag
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_title: tituloPagina,
        page_location: window.location.href,
      });
    }

    // Debug opcional
    //console.log("📊 Page view enviado:", tituloPagina);
  }, [servicio]);

  // 3) Inicializar carrusel de valoraciones (cuando llegan async)
  useEffect(() => {
    if (!Array.isArray(valDestServicio) || valDestServicio.length < 2) return;

    // Bootstrap 5 expone el constructor en window.bootstrap si estás usando el bundle global.
    // Si no existe, el carrusel no podrá auto-inicializarse.
    const bs = (typeof window !== "undefined") ? window.bootstrap : null;
    if (!bs?.Carousel) return;

    const el = document.getElementById("carouselValoraciones");
    if (!el) return;

    try {
      // destruir instancia previa si existía
      const prev = bs.Carousel.getInstance(el);
      if (prev) prev.dispose();

      // crear nueva instancia y activar auto-slide
      const carrusel = new bs.Carousel(el, {
        interval: 4000,
        ride: "carousel",
        pause: false,
        wrap: true,
        touch: true,
      });

      carrusel.cycle();
    } catch (e) {
      console.log("No se pudo inicializar el carrusel de valoraciones:", e);
    }
  }, [valDestServicio]);


 
  // función para ir al ancla reseñas
  function irValoraciones() {
    const el = document.getElementById("seccionValoraciones");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  // ── PREGUNTAS DEL SERVICIO ──────────────────────────────────────────
  const MAX_PREGUNTA = 300;
  const MIN_PREGUNTA = 5;

  // Cargar preguntas públicas del servicio (no requiere sesión)
  async function cargarPreguntas(pagina = 1) {
    if (!idServicio) return;
    setCargandoPreguntas(true);
    try {
      const res = await axios.post("/preguntas-servicio/listar", { idServicio, pagina, limite: 10 });
      const data = res?.data || {};
      if (!data.ok) return;

      setPreguntas((prev) => (pagina === 1 ? data.preguntas : [...prev, ...(data.preguntas || [])]));
      setTotalPreguntas(Number(data.total) || 0);
      setHayMasPreguntas(Boolean(data.hayMas));
      setPaginaPreguntas(pagina);
    } catch (err) {
      console.log("Error cargando preguntas:", err);
    } finally {
      setCargandoPreguntas(false);
    }
  }

  useEffect(() => {
    if (!idServicio) return;
    cargarPreguntas(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idServicio]);

  async function enviarPregunta() {
    // Debe estar logueado para escribir
    if (!usuario) {
      const r = await Swal.fire({
        icon: "info",
        title: "Inicia sesión para preguntar",
        text: "Necesitas una cuenta para hacerle preguntas al vendedor.",
        showCancelButton: true,
        confirmButtonText: "Iniciar sesión",
        cancelButtonText: "Ahora no",
      });
      if (r.isConfirmed) navigate("/iniciar-sesion", { state: { returnTo: location.pathname + location.search } });
      return;
    }

    // No se puede preguntar en el propio servicio
    if (String(usuario.idUsuario) === String(servicio?.idUsuario)) {
      return Swal.fire({ icon: "info", title: "Es tu publicación", text: "No puedes hacer preguntas en tu propio servicio." });
    }

    const texto = nuevaPregunta.trim();
    if (texto.length < MIN_PREGUNTA) {
      return Swal.fire({ icon: "warning", title: "Escribe tu pregunta", text: `La pregunta debe tener al menos ${MIN_PREGUNTA} caracteres.` });
    }
    if (texto.length > MAX_PREGUNTA) {
      return Swal.fire({ icon: "warning", title: "Pregunta muy larga", text: `Máximo ${MAX_PREGUNTA} caracteres.` });
    }

    setEnviandoPregunta(true);
    try {
      const res = await axios.post(
        "/preguntas-servicio/crear",
        { idServicio, pregunta: texto },
        { withCredentials: true }
      );
      const data = res?.data || {};

      if (!data.ok) {
        return Swal.fire({ icon: "error", title: "No pudimos enviar tu pregunta", text: data.mensaje || "Intenta más tarde." });
      }

      setNuevaPregunta("");

      if (data.enRevision) {
        return Swal.fire({ icon: "info", title: "Pregunta en revisión", text: data.mensaje || "Tu pregunta se publicará en unos minutos." });
      }

      // Se publica de inmediato: la mostramos arriba
      if (data.pregunta) {
        setPreguntas((prev) => [
          { ...data.pregunta, avatarUsuario: usuario?.avatar && usuario.avatar !== "NA" ? usuario.avatar : null, usernameUsuario: usuario?.username || null },
          ...prev,
        ]);
        setTotalPreguntas((n) => n + 1);
      }
      Swal.fire({ icon: "success", title: "Pregunta enviada", text: data.mensaje || "El vendedor recibirá tu pregunta." });
    } catch (err) {
      const msg = err?.response?.data?.mensaje || "Ocurrió un error al enviar tu pregunta.";
      Swal.fire({ icon: "error", title: "No pudimos enviar tu pregunta", text: msg });
    } finally {
      setEnviandoPregunta(false);
    }
  }
  
  // función para obtener los faq del servicio
  function obtenerFaqServicio() {
    const reales = Array.isArray(servicio?.faq) ? servicio.faq : [];
    return reales;
  }
  
  // función para mostrar correctamente la duración del servicio
  function formatearEntrega(paquete) {
    const unidad = (paquete?.unidadEntrega || "Dias");
    const unidadNorm = (unidad === "Horas" || unidad === "Dias" || unidad === "Días") ? unidad : "Dias";

    if (unidadNorm === "Horas") {
      const mins = Number(paquete?.duracionCitaMin || 0);
      if (!mins || Number.isNaN(mins) || mins <= 0) return "1 hora";

      const h = Math.floor(mins / 60);
      const m = mins % 60;

      if (h === 0) return `${m} min`;
      if (m === 0) return `${h} hora${h !== 1 ? "s" : ""}`;
      return `${h} hora${h !== 1 ? "s" : ""} ${m} min`;
    }

    const d = Number(paquete?.diasEntrega || 1);
    return `${d} día${d === 1 ? "" : "s"}`;
  }

  
 

  // función para mostrar correctamente la descripción
  function formatearDescripcion(texto) {
    const t = String(texto || "");
    if (!t) return "";

    // Respeta lo que escribió el usuario.
    // Solo evitamos 20 líneas vacías seguidas por error.
    return t.replace(/\n{3,}/g, "\n\n").trim();
  }

  // función para mostrar solo fecha (sin hora) en reseñas
  function formatearFechaSoloDia(valor) {
    if (!valor) return "";

    try {
      const d = (valor instanceof Date) ? valor : new Date(valor);
      if (Number.isNaN(d.getTime())) return "";

      return new Intl.DateTimeFormat("es-CO", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(d);
    } catch (e) {
      return "";
    }
  }

  // usamos en página real
  async function compartirServicio() {
    try {
      const url = window.location.href;
      const title = servicio?.nombre ? `${servicio.nombre} | Zervicy` : "Servicio | Zervicy";
      const text = "Mira este servicio en Zervicy";

      if (navigator.share) {
        await navigator.share({ title, text, url });
        return;
      }

      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        return Swal.fire({ icon: "success", title: "Link copiado", text: "Se copió el enlace del servicio al portapapeles." });
      }

      return Swal.fire({ icon: "info", title: "Compartir", text: "Tu navegador no permite compartir automáticamente en este momento." });
    } 
    catch (err) {
      const nombreError = String(err?.name || "");
      const mensajeError = String(err?.message || "").toLowerCase();

      // Cancelado por el usuario (no es error)
      if (
        nombreError === "AbortError" ||
        mensajeError.includes("share canceled") ||
        mensajeError.includes("cancel")
      ) {
        return; // no hacemos nada
      }

      console.log("Error compartiendo:", err);
      return Swal.fire({ icon: "error", title: "No se pudo compartir", text: "Ocurrió un error al intentar compartir el servicio." });
    }
  }

  // usamos en página real
  async function toggleWishlist() {
    try{
      //setCargando(true);

      const existe = enWishlist ? true : false;

     if(!usuario) return Swal.fire({ icon: "error", title: "Error", text: "Inicia sesión para guardar servicio en tus favoritos." });
      
      // guardar servicio en wishlist
      const resDeseos = await axios.post("/guardar-favorito", {
        params: {usuario: usuario, servicio: servicio, existe: existe }
      });

      if (!existe) {
        const precioActivo = servicio.paquetes?.find(p => p.tipo === paqueteActivo)?.precio || servicio.paquetes?.[0]?.precio || 0;
        pixelAgregarFavorito({ nombre: servicio.nombre, id: servicio.idServicio, precio: precioActivo, categoria: servicio.categoria || "" });
        gtagAgregarFavorito({ nombre: servicio.nombre, id: servicio.idServicio, precio: precioActivo, categoria: servicio.categoria || "" });
        ttqAgregarFavorito({ nombre: servicio.nombre, id: servicio.idServicio, precio: precioActivo, categoria: servicio.categoria || "" });
        eventoAgregarFavorito({ nombre: servicio.nombre, id: servicio.idServicio, precio: precioActivo, usuarioId: usuario?.idUsuario });
      }

      return await Swal.fire({ icon: "success", title: "Favoritos", text: "El servicio ha sido añadido a tus favoritos." })
      .then(() => { window.location.reload();
      }); 
    }
    catch(err){
      console.log("Error al añadir a la lista de deseos. ", err);
      return Swal.fire({ icon: "error", title: "Error", text: "Ocurrió un error al añadir a tu lista de deseos." });
    }
    //finally{setCargando(false);}
  }


  async function reservar(paqueteSeleccionado){
    const seleccionado = paqueteSeleccionado.tipo;
    //console.log("paquete seleccionado: ", seleccionado); // Básico, Premium, Avanzado

    // si el usuario que compra es el mismo proveedor
    if (usuario && usuario.idUsuario === servicio.idUsuario){
      return Swal.fire({ icon: "error", title: "Error", text: "No puedes comprar tu propio servicio." });
    }

    try{
      const resReserva = await axios.post("/crear-reserva", {
        params: {
          idServicio: servicio.idServicio,
          paquete: seleccionado,
          ...(usuario ? { idComprador: usuario.idUsuario } : { idInvitado: obtenerIdInvitado() }),
          idProveedor: servicio.idUsuario, // vendedor del servicio
          origen: "web",
        }
      });

      // EJECUTAMOS EL EVENTO DE AGREGAR AL CARRITO (equivale a AddToCart): el momento exacto
      // en que el usuario elige un paquete y arranca la reserva, antes de fecha/hora/pago.
      pixelAgregarAlCarrito({
        nombre:    servicio.nombre,
        id:        servicio.idServicio,
        precio:    paqueteSeleccionado.precio || 0,
        categoria: servicio.categoria || "",
      });
      gtagAgregarAlCarrito({
        nombre:    servicio.nombre,
        id:        servicio.idServicio,
        precio:    paqueteSeleccionado.precio || 0,
        categoria: servicio.categoria || "",
      });
      ttqAgregarAlCarrito({
        nombre:    servicio.nombre,
        id:        servicio.idServicio,
        precio:    paqueteSeleccionado.precio || 0,
        categoria: servicio.categoria || "",
      });
      eventoAgregarAlCarrito({
        nombre:    servicio.nombre,
        id:        servicio.idServicio,
        precio:    paqueteSeleccionado.precio || 0,
        usuarioId: usuario?.idUsuario,
      });

      Swal.fire({
        icon: "success",
        title: "Reserva iniciada",
        text: "Completa la reserva a continuación.",
        confirmButtonText: "Continuar",
        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/reserva");
        }
    });
    }
    catch(err){
      console.log("Error al reservar. ", err);
      return Swal.fire({ icon: "error", title: "Error", text: "Ocurrió un error al reservar el servicio." });
    }

    
  }

  
  const tituloSEO = servicio?.nombre ? `${servicio.nombre} | Zervicy` : "Servicio | Zervicy";
  const descripcionSEO = servicio?.descripcion
    ? servicio.descripcion.slice(0, 160)
    : "Reserva servicios profesionales de forma fácil y segura en Zervicy.";
  // Primera imagen válida del servicio — si no hay ninguna, HelmetSEO/index.html ya
  // trae un logo de respaldo, así que no hace falta un fallback acá.
  const imagenSEO = (Array.isArray(servicio?.imagenes) ? servicio.imagenes : []).find(Boolean);

  return (
    <>
      <Helmet>
        {/* SEO: título principal que aparece en Google y pestaña del navegador */}
        <title>{tituloSEO}</title>

        {/* SEO: descripción corta para Google y redes sociales */}
        <meta name="description" content={descripcionSEO} />

        {/* Open Graph / Facebook / WhatsApp / LinkedIn — cubre navegación dentro de la app (SPA);
            la carga inicial del link ya la resuelve servidor.js (ruta /servicio/:nombreYid). */}
        <meta property="og:title" content={tituloSEO} />
        <meta property="og:description" content={descripcionSEO} />
        {imagenSEO && <meta property="og:image" content={imagenSEO} />}

        {/* Twitter / X */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={tituloSEO} />
        <meta name="twitter:description" content={descripcionSEO} />
        {imagenSEO && <meta name="twitter:image" content={imagenSEO} />}
      </Helmet>

    <div>
    {cargandoFinal ? <ZonaCargando />
    : ( servicio && vendedor ) ? 
    <div className="contenedorAdaptador">
      <div className="container my-4">
        <div>

          {/* Header */}
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom border-dark">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 w-100">
              {/* TITULO  Y MIGAS DE PAN*/}
              <div>
                <h1 className="h2 text-dark mb-0">{servicio.nombre}</h1>

                {/* MIGAS DE PAN */}
                <nav aria-label="breadcrumb" className="mb-1">
                  <ol className="breadcrumb mb-0">
                    {/* HOME */}
                    <li className="breadcrumb-item"> <a href="/" className="text-decoration-none">Home</a> </li>

                    {/* CATEGORÍA */}
                    {servicio?.categoria ?
                    <li className="breadcrumb-item">
                        <button
                            type="button"
                            className="btn btn-link p-0 border-0 align-baseline text-decoration-none"
                            onClick={() => navigate("/busqueda", { state: { filtros: { categoria: servicio.categoria, subcategoria: null } } })}
                        >
                            {servicio.categoria}
                        </button>
                    </li>
                    : null}

                    {/* SUBCATEGORIA */}
                    {servicio?.subcategoria ?
                    <li className="breadcrumb-item">
                        <button
                            type="button"
                            className="btn btn-link p-0 border-0 align-baseline text-decoration-none"
                            onClick={() => navigate("/busqueda", { state: { filtros: { categoria: servicio.categoria, subcategoria: servicio.subcategoria } } })}
                        >
                            {servicio.subcategoria}
                        </button>
                    </li>
                    : null}
                    
                    {/* NOMBRE SERVICIO */}
                    <li className="breadcrumb-item active" aria-current="page"> {servicio?.nombre || "Servicio"} </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>

          {/* Contenido */}
          {!servicio ? <div className="alert alert-warning" role="alert"> No hay información para mostrar en el preview. </div>
          : <div className="row g-4">

            {/* Izquierda: galería + descripción */}
            <div className="col-12 col-lg-7">

              {/* CONTENEDOR 1: IMAGENES Y DESCRIPCIÓN */}
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  {/* CONTENEDOR 1: TITULO Y RESEÑAS */}
                  <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                    {/* TITULOS */}
                    <h4 className="mb-0">Detalles del servicio</h4>

                    {/* RESEÑAS */}
                    {(() => {
                      if (resuServicio.cantidad <= 0) return null;

                      return (
                        <button type="button" className="btn btn-link p-0 text-decoration-none" onClick={irValoraciones} title="Ver reseñas del servicio" >
                          <span className="text-primary" style={{ letterSpacing: 1 }}>{estrellas(resuServicio?.cantidadEstrellas)}</span>
                          <span className="ms-2 fw-semibold text-dark">{resuServicio?.valoracionFinal}</span>
                          <small className="ms-2 text-muted">({resuServicio?.cantidad} reseñas)</small>
                        </button>
                      );
                    })()}
                  </div>
                  
                  {/* CONTENEDOR 2: CATEGORIZACIÓN, LIKE Y COMPARTIR */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    {/* CATEGORÍAS */}
                    <div className="d-flex flex-wrap gap-2">
                      <span className="badge bg-dark">{servicio.categoria || "NA"}</span>
                      <span className="badge bg-secondary">{servicio.subcategoria || "NA"}</span>
                      {/* <span className="badge bg-info text-dark">Estado: {servicio.estado || "Borrador"}</span> */}
                    </div>
                    
                    {/* FAVORITOS Y COMPARTIR */}
                    <div className="btn-group">
                      {/* FAVORITOS */}
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={toggleWishlist}
                        title="Añadir a mi lista de deseos"
                      >
                        <i className={`bi ${enWishlist ? "bi-heart-fill text-primary" : "bi-heart text-muted"}`}></i>
                      </button>

                      {/* COMPARTIR */}
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={compartirServicio}
                        title="Compartir"
                      >
                        <i className="bi bi-share"></i>
                      </button>
                    </div>
                  </div>

                  
                  {/* IMAGENES */}
                  {(() => {
                    const imagenesValidas = (Array.isArray(servicio.imagenes) ? servicio.imagenes : []).filter(Boolean).slice(0, 8);
                    if (imagenesValidas.length === 0) {
                      return <div className="alert alert-secondary mb-0" role="alert"> Aún no hay imágenes para mostrar.</div>;
                    }

                    return (
                    <div>
                      {/* CARRUSEL PRINCIPAL */}
                      <div id="carouselServicio" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner rounded">
                          {imagenesValidas.map((url, idx) => (
                            <div className={`carousel-item ${idx === 0 ? "active" : ""}`} key={idx}>
                              <div style={{ position: 'relative' }}>
                                <img
                                  src={url}
                                  className="d-block w-100"
                                  alt={`img-${idx}`}
                                  style={{ maxHeight: 440, objectFit: "cover", cursor: "zoom-in" }}
                                  onClick={() => setImagenExpandida(url)}
                                />
                                <button
                                  type="button"
                                  onClick={() => setImagenExpandida(url)}
                                  title="Ver imagen completa"
                                  style={{ position: 'absolute', bottom: 10, right: 10, width: 32, height: 32, borderRadius: '50%', border: 'none', backgroundColor: 'rgba(var(--negro-rgb), 0.55)', color: 'var(--blanco)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                >
                                  <i className="bi bi-arrows-fullscreen"></i>
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* FLECHAS ATRÁS Y ADELANTE */}
                        {imagenesValidas.length > 1 ?
                        <div>
                          <button className="carousel-control-prev" type="button" data-bs-target="#carouselServicio" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button className="carousel-control-next" type="button" data-bs-target="#carouselServicio" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </div>
                        : null}
                      </div>

                      {/* MINIATURAS */}
                      <div className="filaMiniaturasScroll mt-2">
                        {imagenesValidas.map((url, idx) => (
                          <img
                            key={idx}
                            src={url}
                            alt={`thumb-${idx}`}
                            className="rounded"
                            style={{ height: 70, width: 90, flex: "0 0 auto", objectFit: "cover", cursor: "pointer" }}
                            data-bs-target="#carouselServicio"
                            data-bs-slide-to={idx}
                          />
                        ))}
                      </div>
                    </div>
                    );
                  })()}

                  {/* DESCRIPCIÓN */}
                  {servicio.descripcion ? 
                  <div className="mt-4">
                    <h6 className="mb-1">Descripción</h6>
                    
                    <div className="texto-regular" style={{ whiteSpace: "pre-wrap", lineHeight: 1.7 }}>
                      {formatearDescripcion(servicio.descripcion)}
                    </div>
                  </div>
                  : null}

                </div>
              </div>




              {/* FAQ */}
              <div className="mt-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                      <h5 className="mb-0">Preguntas frecuentes</h5>
                      
                    </div>
                    {(() => {
                      const listaFaq = obtenerFaqServicio();
                      const cantidadFaq = typeof window !== "undefined" && window._previewCantidadFaq !== undefined ? window._previewCantidadFaq : 3;
                      const total = Array.isArray(listaFaq) ? listaFaq.length : 0;

                      if (total <= 0) return ( <div className="text-muted mt-2">Aún no hay preguntas frecuentes para este servicio.</div> );

                      return (
                        <div className="accordion" id="faqAccordion">
                          {listaFaq.slice(0, cantidadFaq).map((faq, idx) => (
                            <div className="accordion-item" key={idx}>
                            {/* TITULO */}
                              <h2 className="accordion-header" id={`faqHeading${idx}`}>
                                <button
                                  className={`accordion-button${idx !== 0 ? " collapsed" : ""}`}
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#faqCollapse${idx}`}
                                  aria-expanded={idx === 0 ? "true" : "false"}
                                  aria-controls={`faqCollapse${idx}`}
                                >
                                  {faq.pregunta}
                                </button>
                              </h2>

                              {/* RESPUESTA */}
                              <div
                                id={`faqCollapse${idx}`}
                                className={`accordion-collapse collapse${idx === 0 ? " show" : ""}`}
                                aria-labelledby={`faqHeading${idx}`}
                                data-bs-parent="#faqAccordion"
                              >
                                <div className="accordion-body"> {faq.respuesta} </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>


              {/* PREGUNTAS SOBRE EL SERVICIO */}
              <div className="mt-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                      <h5 className="mb-0">Preguntas sobre el servicio</h5>
                      {totalPreguntas > 0 ? <small className="text-muted">{totalPreguntas} pregunta{totalPreguntas !== 1 ? "s" : ""}</small> : null}
                    </div>

                    {/* INPUT NUEVA PREGUNTA */}
                    {usuario && String(usuario.idUsuario) === String(servicio?.idUsuario) ? (
                      <div className="mb-3 text-muted small">
                        <i className="bi bi-info-circle me-1"></i>
                        Esta es tu publicación. Aquí verás las preguntas de los compradores para responderlas.
                      </div>
                    ) : (
                      <div className="mb-3">
                        <textarea
                          className="form-control"
                          rows={2}
                          maxLength={MAX_PREGUNTA}
                          placeholder="Escribe tu pregunta sobre este servicio…"
                          value={nuevaPregunta}
                          onChange={(e) => setNuevaPregunta(e.target.value)}
                          disabled={enviandoPregunta || !usuario}
                        />

                        {usuario ? (
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-2">
                            <small className="text-muted">
                              {nuevaPregunta.length}/{MAX_PREGUNTA} · No compartas teléfonos, correos ni direcciones.
                            </small>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={enviarPregunta}
                              disabled={enviandoPregunta}
                            >
                              {enviandoPregunta ? "Enviando…" : "Preguntar"}
                            </button>
                          </div>
                        ) : (
                          <button
                            type="button"
                            onClick={enviarPregunta}
                            className="w-100 mt-2 d-flex align-items-center justify-content-center gap-2 py-2 px-3"
                            style={{
                              background: "rgba(var(--azul-logo-claro-rgb), 0.05)",
                              border: "1px solid rgba(var(--azul-logo-claro-rgb), 0.18)",
                              color: "var(--azul-logo-claro)",
                              borderRadius: 10,
                              fontWeight: 600,
                            }}
                          >
                            <i className="bi bi-box-arrow-in-right"></i>
                            Inicia sesión para preguntarle al vendedor
                          </button>
                        )}
                      </div>
                    )}

                    {/* LISTA DE PREGUNTAS */}
                    {preguntas.length === 0 ? (
                      <div className="text-muted">{cargandoPreguntas ? "Cargando preguntas…" : "Aún no hay preguntas. ¡Sé el primero en preguntar!"}</div>
                    ) : (
                      <ul className="list-unstyled mb-0">
                        {preguntas.map((q) => (
                          <li key={q.idPregunta} className="border-top pt-3 mt-3">
                            <div className="d-flex align-items-center gap-2 mb-1">
                              {q.avatarUsuario ? (
                                <img
                                  src={q.avatarUsuario}
                                  alt={q.usuarioPregunta}
                                  style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", flexShrink: 0, border: "1.5px solid var(--color-border)" }}
                                />
                              ) : (
                                <div style={{ width: 32, height: 32, borderRadius: "50%", background: "var(--color-border)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: "var(--gris-suave)", flexShrink: 0 }}>
                                  {(q.usuarioPregunta || "?").charAt(0).toUpperCase()}
                                </div>
                              )}
                              <div>
                                {q.usernameUsuario ? (
                                  <Link to={`/${q.usernameUsuario}`} className="fw-semibold text-dark text-decoration-none">{q.usuarioPregunta}</Link>
                                ) : (
                                  <span className="fw-semibold">{q.usuarioPregunta}</span>
                                )}
                                <small className="text-muted ms-2">{formatearFechaSoloDia(q.createdAt)}</small>
                              </div>
                            </div>
                            <p className="mb-1">{q.pregunta}</p>
                            {q.respondida && q.respuesta ? (
                              <div className="ms-4 ps-2 border-start">
                                <small className="text-muted d-block">Respuesta del vendedor</small>
                                <p className="mb-0">{q.respuesta}</p>
                              </div>
                            ) : (
                              <small className="text-muted ms-4">Sin responder aún</small>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}

                    {hayMasPreguntas ? (
                      <div className="text-center mt-3">
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => cargarPreguntas(paginaPreguntas + 1)}
                          disabled={cargandoPreguntas}
                        >
                          {cargandoPreguntas ? "Cargando…" : "Ver más preguntas"}
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>


              {/* CONTENEDOR 2: POLÍTICAS */}
              <div className="card border-0 shadow-sm mt-4">
                <div className="card-body">
                  <h5 className="mb-2">Políticas</h5>
                  <div className="texto-regular" style={{ lineHeight: 1.7 }}>
                    <p className="mb-2">
                      <strong>Pago protegido:</strong> No desembolsamos tu pago al prestador del servicio hasta que finalice el tiempo del servicio y tú confirmes que fue realizado correctamente.
                    </p>
                    <p className="mb-2">
                      <strong>Cancelación y devoluciones:</strong> Puedes cancelar sin costo antes de que el vendedor inicie el trabajo.
                      Si el trabajo ya inició, la devolución puede ser parcial según el avance y el acuerdo por chat.
                    </p>
                    <p className="mb-0">
                      Para más detalles revisa nuestra política completa.
                      {" "}
                      <a href="/cancelacion" className="link-primary text-decoration-none"> Ver política de cancelación </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Derecha: vendedor + selección de paquete */}
            <div className="col-12 col-lg-5">
              <div className="sticky-top" style={{ top: 90 }}>

                {/* VENDEDOR */}
                <CardVendedor vendedor={vendedor} resuVendedor={resuVendedor}/>

                {/* PAQUETES */}
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <h5 className="mb-3">Elige un paquete</h5>

                    {Array.isArray(servicio.paquetes) && servicio.paquetes.length > 0 ? 
                      <div>
                        {/* TAB TITULO DEL PAQUETE */}
                        <ul className="nav nav-tabs" role="tablist">
                          {servicio.paquetes.map((p, idx) => (
                            <li className="nav-item" role="presentation" key={idx}>
                              <button
                                className={`nav-link ${paqueteActivo === p.tipo || (!paqueteActivo && idx === 0) ? "active" : ""}`}
                                type="button"
                                role="tab"
                                onClick={() => {
                                  setPaqueteActivo(p.tipo);
                                  // CREAMOS EL EVENTO DEL PIXEL FACEBOOK VER CONTEIDO CUANDO CAMBIAMOS DE PAQUETE
                                  pixelVerContenido({
                                    nombre:    servicio.nombre,
                                    id:        servicio.idServicio,
                                    precio:    p.precio || 0,
                                    categoria: servicio.categoria || "",
                                  });
                                  gtagVerContenido({
                                    nombre:    servicio.nombre,
                                    id:        servicio.idServicio,
                                    precio:    p.precio || 0,
                                    categoria: servicio.categoria || "",
                                  });
                                  ttqVerContenido({
                                    nombre:    servicio.nombre,
                                    id:        servicio.idServicio,
                                    precio:    p.precio || 0,
                                    categoria: servicio.categoria || "",
                                  });
                                  eventoVerContenido({
                                    nombre:    servicio.nombre,
                                    id:        servicio.idServicio,
                                    precio:    p.precio || 0,
                                    categoria: servicio.categoria || "",
                                    usuarioId: usuario?.idUsuario,
                                  });
                                }}
                              >
                                {p.tipo}
                              </button>
                            </li>
                          ))}
                        </ul>

                        {/* DESCRIPCIÓN DEL PAQUETE  */}
                        <div className="border border-top-0 rounded-bottom p-3">
                          {(() => {
                            const p = servicio.paquetes.find(x => x.tipo === paqueteActivo) || servicio.paquetes[0];
                            if (!p) return null;

                            const desglose = desglosePorPaquete[p.tipo] || null;
                            const precioMostrado = desglose?.totalCliente || p?.precio;

                            return (
                              <div>
                                {/* TIPO, ENTREGA Y PRECIO */}
                                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                  {/* TIPO Y ENTREGA */}
                                  <div>
                                    <div className="fw-semibold">{p.tipo}</div>
                                    <small className="text-muted">Duración: {formatearEntrega(p)}</small>
                                  </div>
                                  {/* PRECIO */}
                                  <div className="text-end">
                                    <div className="fw-semibold" style={{ fontSize: 18 }}>
                                      {formatearMoneda(precioMostrado, p?.divisa || "COP")}
                                    </div>
                                    <small className="text-muted">Precio final, incluye costos de servicio</small>
                                  </div>
                                </div>

                                {/* DESCRPCIOÓN */}
                                {p.descripcion && p.descripcion !== "NA" ? 
                                <p className="mt-2 mb-2">{p.descripcion}</p>
                                : null}
                                
                                {/* DETALLES */}
                                {Array.isArray(p.detalles) && p.detalles.length > 0 ? 
                                <ul className="mb-0 texto-regular" style={{ lineHeight: 1.7 }}>
                                  {p.detalles.slice(0, 12).map((d, i) => (
                                    <li key={i}>{d}</li>
                                  ))}
                                </ul>
                                : null}
                                
                                {/* BOTON ORDENAR */}
                                <button
                                  type="button"
                                  className="btn btn-primary w-100 mt-3 botonReservar"
                                  onClick={() => reservar(p)}
                                >
                                  Reservar
                                </button>

                                {/* MÉTODOS DE PAGO ACEPTADOS */}
                                <img
                                  src="/imagenes/pagoswompi.png"
                                  alt="Pagos seguros con Visa, Mastercard, American Express, DaviPlata, Nequi y PSE"
                                  className="d-block mx-auto mt-3"
                                  style={{ maxWidth: 340, width: "100%", height: "auto" }}
                                />
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                    : <div className="alert alert-secondary mb-0" role="alert"> Aún no hay paquetes para mostrar. </div>
                    }

                  </div>
                </div>

                {/* LLÁMANOS: acompañamiento/confianza justo después de elegir el paquete */}
                <div className="mt-4">
                  <Llamanos />
                </div>

                {/* TIPO */}
                <TipoYubicacion servicio={servicio} desdeDonde={"Global"} />

               

                {/* VALORACIONES */}
                <div id="seccionValoraciones"></div> 
                <div className="mt-4">
                  <div className="card border-0 shadow-sm">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                        <h5 className="mb-0">Reseñas</h5>
                        <small className="text-muted">(Lo que dicen los compradores)</small>
                      </div>

                      <div id="carouselValoraciones" className="carousel slide" data-bs-ride="carousel" data-bs-interval="4000" data-bs-touch="true">
                        {/* VALORACIONES */}
                        <div className="carousel-inner">
                          {valDestServicio.map((r, idx) => (
                            <div className={`carousel-item ${idx === 0 ? "active" : ""}`} key={idx}>
                              <div className="border rounded p-3 bg-white">
                                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                  <div className="d-flex align-items-center gap-2">
                                    {r.avatarUsuario ? (
                                      <img
                                        src={r.avatarUsuario}
                                        alt={r.nombreUsuario}
                                        style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover", flexShrink: 0, border: "1.5px solid var(--color-border)" }}
                                      />
                                    ) : (
                                      <div style={{ width: 36, height: 36, borderRadius: "50%", background: "var(--color-border)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 700, color: "var(--gris-suave)", flexShrink: 0 }}>
                                        {(r.nombreUsuario || "?").charAt(0).toUpperCase()}
                                      </div>
                                    )}
                                    <div>
                                      {r.usernameUsuario ? (
                                        <Link to={`/${r.usernameUsuario}`} className="fw-semibold text-dark text-decoration-none">
                                          {r.nombreUsuario}
                                        </Link>
                                      ) : (
                                        <div className="fw-semibold">{r.nombreUsuario}</div>
                                      )}
                                      <div className="text-primary" style={{ letterSpacing: 1 }}>{estrellas(r.calificacion)}</div>
                                    </div>
                                  </div>
                                  <small className="text-muted">{formatearFechaSoloDia(r.fecha)}</small>
                                </div>
                                <p className="mt-2 mb-0">{r.comentario}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                        
                        {/* FLECHAS ATRAS ADELANTE */}
                        {valDestServicio.length > 1 ? 
                        <div>
                          <button className="carousel-control-prev" type="button" data-bs-target="#carouselValoraciones" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button className="carousel-control-next" type="button" data-bs-target="#carouselValoraciones" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </div>
                        : null}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          }

          {/* SERVICIOS RELACIONADOS: al final a propósito, lejos del botón de reservar */}
          <ServiciosRelacionados
            idServicio={servicio.idServicio}
            nombreVendedor={(vendedor?.nombre && vendedor.nombre !== "NA") ? vendedor.nombre : vendedor?.username}
            usuario={usuario}
          />

        </div>
      </div>
    </div>
    : null}

    {/* LIGHTBOX: ver imagen completa */}
    {imagenExpandida && (
      <div
        onClick={() => setImagenExpandida(null)}
        style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(var(--negro-rgb), 0.9)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', cursor: 'zoom-out' }}
      >
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setImagenExpandida(null); }}
          title="Cerrar"
          style={{ position: 'absolute', top: 16, right: 16, width: 36, height: 36, borderRadius: '50%', border: 'none', backgroundColor: 'rgba(var(--blanco-rgb), 0.15)', color: 'var(--blanco)', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <i className="bi bi-x-lg"></i>
        </button>
        <img
          src={imagenExpandida}
          alt="Vista completa"
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8 }}
        />
      </div>
    )}
    </div>
  </>
  );
}

export default VerServicio;